// @core/api/endpoints/signature/create_signature_request.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateSignatureRequestRequest,
  SignatureRequestResponse,
} from '../../../types/signature';

const BASE_PATH = '/signature';

/**
 * Create an internal qualified signature request
 * Creates an IN_PROGRESS request for an existing party and an immutable SHA-256 content hash.
 */
export async function CreateSignatureRequest(
  data: CreateSignatureRequestRequest,
  options?: RequestOptions
): Promise<SignatureRequestResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/requests`;
  const requestOptions = options;
  return client.post<SignatureRequestResponse>(requestPath, data, requestOptions);
}
